// The intake form fields (architecture plan §7.1), shared by the API, the web form, the
// `requests` table, and the fixture corpus in `packages/boardstd`, so none of them can drift.
//
// Requester name, email, and department-of-record are not here: they come from the verified
// Entra token, never from free text (§8.2). Attachments are metadata only and arrive in P12.

import { z } from "zod";

export const BUSINESS_IMPACTS = ["individual", "multiple_people", "company_wide"] as const;
export const BusinessImpactSchema = z.enum(BUSINESS_IMPACTS);
export type BusinessImpact = z.infer<typeof BusinessImpactSchema>;

export const ONSITE_OR_REMOTE = ["onsite", "remote"] as const;
export const OnsiteOrRemoteSchema = z.enum(ONSITE_OR_REMOTE);
export type OnsiteOrRemote = z.infer<typeof OnsiteOrRemoteSchema>;

export const RequestFormFieldsSchema = z.object({
  /** From the configured category list (`categories.ts`). Validated against it at intake. */
  category: z.string().min(1),
  subject: z.string().min(1),
  description: z.string().min(1),
  department: z.string().min(1),
  location: z.string().min(1),
  onsiteOrRemote: OnsiteOrRemoteSchema,
  callback: z.string().min(1),
  affectedSystemOrDevice: z.string(),
  onset: z.string(),
  errorText: z.string(),
  troubleshootingAttempted: z.string(),
  businessImpact: BusinessImpactSchema,
  neededBy: z.string().nullable(),
  sponsor: z.string().nullable(),
  sensitivityAcknowledged: z.boolean(),
  /**
   * Answers to the category's follow-up fields (`categories.ts`), keyed by field id. Kept as a
   * map because the field set is category configuration, not a fixed column list.
   */
  followUpAnswers: z.record(z.string(), z.unknown()).default({}),
});
export type RequestFormFields = z.infer<typeof RequestFormFieldsSchema>;
export type RequestFormFieldsInput = z.input<typeof RequestFormFieldsSchema>;
